import { Add, Delete, Edit, HistoryTwoTone } from "@material-ui/icons";
import {
  Card,
  CardContent,
  Divider as MuiDivider,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import React, { createRef, useState } from "react";
import { deleteSailor, fetchSailors } from "../../../services/sailorService";
import { Autocomplete } from "@material-ui/lab";
import CreateDialog from "./CreateDialog";
import CustomAlert from "../../components/CustomAlert";
import CustomTable from "../../../components/GovGrMaterialTable";
import { Helmet } from "react-helmet-async";
import UpdateDialog from "./UpdateDialog";
import ViewDialog from "./ViewDialog";
import dayjs from "dayjs";
import { fetchPortAuthorities } from "../../../services/portAuthoritiesService";
import queryFunction from "../../../utils/queryFunction";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import useLocale from "../../../hooks/useLocale";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";

import GovGrBreadcrumbs from "../../../components/GovGrBreadCrumbs";
import GovGrCard from "../../../components/GovGrCard";
import GovGrDeleteModalDialog from "../../../components/GovGrDeleteModalDialog";

const Divider = styled(MuiDivider)(spacing);

const useStyles = makeStyles({
  viewDetails: {
    width: 700,
    height: 400,
  },
  card: {
    marginTop: "1rem",
    marginBottom: "1.5rem",
  },
  applicationCard: {
    maxWidth: "80vw",
  },
});

function Marines() {
  const { t } = useLocale();
  const classes = useStyles();

  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isUpdateDialogOpen, setIsUpdateDialogOpen] = useState(false);
  const [isViewDialogOpen, setIsViewDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [isError, setIsError] = useState(false);

  const tableRef = createRef();

  const refreshTable = () => {
    if (tableRef.current) {
      tableRef.current.onQueryChange();
    }
  };

  const [portAuthId, setportAuthId] = useState(
    useSelector((state) => state?.authReducer?.user?.port_auth_id)
  );
  const auth_level = useSelector(
    (state) => state?.authReducer?.user?.auth_level
  );

  const { data: PortAuthorities } = useQuery(
    "portAuthorities",
    fetchPortAuthorities
  );

  return (
    <>
      <Helmet title={t("Sailors")} />
      <Typography variant="h3" gutterBottom display="inline">
        {t("Sailors")}
      </Typography>

      <GovGrBreadcrumbs
        segments={[
          { href: "/", label: t("Dashboard") },
          { href: "#", label: t("Nautical Crew List") },
        ]}
      />

      <Divider my={6} />

      {auth_level === 0 && PortAuthorities ? (
        <Card className={classes.card} elevation={3}>
          <CardContent className={classes.applicationCard}>
            <Autocomplete
              id="combo-box-demo"
              onChange={(event, newValue) => {
                setportAuthId(newValue?.id);
              }}
              options={PortAuthorities || []}
              getOptionLabel={(option) => option?.dscr}
              style={{ width: 300, marginTop: 10 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t("Port Authorities")}
                  variant="outlined"
                />
              )}
            />
          </CardContent>
        </Card>
      ) : null}

      <CustomAlert
        open={isError}
        close={() => {}}
        message={t("A network error occured, please try again later")}
      />
      <GovGrCard>
        <CustomTable
          ref={tableRef}
          columns={[
            // {
            //   title: t("Sailor Identification Number"),
            //   field: "s_am",
            // },
            {
              title: t("Ameth"),
              field: "s_ameth",
            },
            {
              title: t("First Name"),
              field: "s_first_name",
            },
            {
              title: t("Last Name"),
              field: "s_last_name",
            },
            {
              title: t("Father Name"),
              field: "s_f_name",
            },
            {
              title: t("Mother name"),
              field: "s_m_name",
            },
            {
              title: t("Birth Date"),
              field: "s_birth_date",
              render: (rowData) => {
                return (
                  <span>
                    {dayjs(rowData?.s_birth_date).format("DD/MM/YYYY")}
                  </span>
                );
              },
            },
            {
              title: t("ANI"),
              field: "s_ani",
            },
            {
              title: t("Diploma Kind"),
              field: "d_name",
            },
          ]}
          data={(query) => queryFunction(query, fetchSailors, setIsError)}
          actions={[
            {
              icon: () => <Add />,
              tooltip: t("Add"),
              isFreeAction: true,
              onClick: () => {
                setIsCreateDialogOpen(true);
              },
            },
            // {
            //   icon: () => <HistoryTwoTone style={{ color: "#000" }} />,
            //   tooltip: t("View History"),
            //   onClick: (event, rowData) => {
            //     setIsViewDialogOpen(true);
            //     setSelectedItem(rowData);
            //   },
            // },
            {
              icon: () => <Edit style={{ color: "#1E90FF" }} />,
              tooltip: t("Edit"),
              onClick: (event, rowData) => {
                setIsUpdateDialogOpen(true);
                setSelectedItem(rowData);
              },
            },
            {
              icon: () => <Delete style={{ color: "#B22222" }} />,
              tooltip: t("Delete"),
              onClick: (event, rowData) => {
                setIsDeleteDialogOpen(true);
                setSelectedItem(rowData);
              },
            },
          ]}
        />
      </GovGrCard>

      <CreateDialog
        open={isCreateDialogOpen}
        close={() => setIsCreateDialogOpen(false)}
        refetch={refreshTable}
      />
      <UpdateDialog
        open={isUpdateDialogOpen}
        close={() => setIsUpdateDialogOpen(false)}
        refetch={refreshTable}
        selectedItem={selectedItem}
      />
      <ViewDialog
        open={isViewDialogOpen}
        close={() => setIsViewDialogOpen(false)}
        refetch={refreshTable}
        selectedItem={selectedItem}
      />

      <GovGrDeleteModalDialog
        title={t("Delete Sailor")}
        open={isDeleteDialogOpen}
        close={() => setIsDeleteDialogOpen(false)}
        message={t(
          "Are you sure you want to delete the selected Sailor with Sailor Identification Number"
        )}
        fieldName="s_ameth"
        idFieldName="d_id"
        refetch={refreshTable}
        selectedItem={selectedItem}
        deleteService={deleteSailor}
      />
    </>
  );
}

export default Marines;
